// /* eslint-disable @typescript-eslint/no-explicit-any */
// import { useTranslation } from 'react-i18next';
// // import { ShepherdTour, ShepherdTourContext, Step } from 'react-shepherd';
// import { useContext } from 'react';
// import { HelpIcon } from '@/icons';

// import 'shepherd.js/dist/css/shepherd.css';

const SmartBookTour: React.FC = () => {
  // const { t } = useTranslation('translation', { keyPrefix: 'tour' });
  // let instance: any | null = null;

  // const tourSteps: Step.StepOptions[] = [
  //   {
  //     id: 'tools',
  //     title: t('tools'),
  //     text: t('tools_content'),
  //     attachTo: { element: '.tool-box', on: 'right' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         action: () => instance.cancel(),
  //         classes: 'obro-btn obro-primary-btn',
  //         text: t('cancel'),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'tool-box-simple-view',
  //     title: t('tool_box_simple_view'),
  //     text: t('tool_box_simple_view_content'),
  //     attachTo: { element: '.tool-box-footer', on: 'bottom' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('cancel'),
  //         classes: 'obro-btn obro-primary-btn',
  //         action: () => instance.cancel(),
  //       },
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'side-tools',
  //     title: t('page_navigations'),
  //     text: t('page_navigations_content'),
  //     attachTo: { element: '.side-tools', on: 'left' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('cancel'),
  //         classes: 'obro-btn obro-primary-btn',
  //         action: () => instance.cancel(),
  //       },
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'book-contents',
  //     title: t('book_contents'),
  //     text: t('book_contents_content'),
  //     attachTo: { element: '.book-content-btn', on: 'top' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('cancel'),
  //         classes: 'obro-btn obro-primary-btn',
  //         action: () => instance.cancel(),
  //       },
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'addnote',
  //     title: t('add_note'),
  //     text: t('add_note_content'),
  //     attachTo: { element: '.add-note-btn', on: 'top' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('cancel'),
  //         classes: 'obro-btn obro-primary-btn',
  //         action: () => instance.cancel(),
  //       },
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'whiteboard',
  //     title: t('white_board'),
  //     text: t('white_board_content'),
  //     attachTo: { element: '.white-board-btn', on: 'top' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('cancel'),
  //         classes: 'obro-btn obro-primary-btn',
  //         action: () => instance.cancel(),
  //       },
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'savedPages',
  //     title: t('saved_pages'),
  //     text: t('saved_pages_content'),
  //     attachTo: { element: '.saved-page-btn', on: 'bottom' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('cancel'),
  //         classes: 'obro-btn obro-primary-btn',
  //         action: () => instance.cancel(),
  //       },
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'numerator',
  //     title: t('numerator'),
  //     text: t('numerator_content'),
  //     attachTo: { element: '.navigator-btn', on: 'top' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('cancel'),
  //         classes: 'obro-btn obro-primary-btn',
  //         action: () => instance.cancel(),
  //       },
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'tools',
  //     title: t('tools'),
  //     text: t('tools_content'),
  //     attachTo: { element: '.tools-header-btn', on: 'bottom' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('cancel'),
  //         classes: 'obro-btn obro-primary-btn',
  //         action: () => instance.cancel(),
  //       },
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'settings',
  //     title: t('settings'),
  //     text: t('settings_content'),
  //     attachTo: { element: '.settings-header-btn', on: 'bottom' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('cancel'),
  //         classes: 'obro-btn obro-primary-btn',
  //         action: () => instance.cancel(),
  //       },
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('next'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.next(),
  //       },
  //     ],
  //   },
  //   {
  //     id: 'fullscreen',
  //     title: t('fullScreen'),
  //     text: t('fullScreen_content'),
  //     attachTo: { element: '.fullscreen-header-btn', on: 'top' },
  //     cancelIcon: {
  //       enabled: true,
  //     },
  //     buttons: [
  //       {
  //         text: t('previous'),
  //         classes: 'obro-btn obro-light-btn border',
  //         action: () => instance.back(),
  //       },
  //       {
  //         text: t('finish'),
  //         classes: 'obro-btn obro-secondary-btn',
  //         action: () => instance.cancel(),
  //       },
  //     ],
  //   },
  // ];

  // const HelpComponent: React.FC = () => {
  //   const tour = useContext(ShepherdTourContext);
  //   instance = tour;
  //   return (
  //     <button
  //       className="obro-btn obro-light-gray-btn"
  //       onClick={() => tour?.start()}
  //     >
  //       <HelpIcon className={undefined} color={undefined} />
  //       {t('help')}
  //     </button>
  //   );
  // };

  return (
    <div></div>
    // <ShepherdTour
    //   steps={tourSteps}
    //   tourOptions={{
    //     useModalOverlay: true,
    //   }}
    // >
    //   <HelpComponent />
    // </ShepherdTour>
  );
};

export default SmartBookTour;
